module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Marco Vassi\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Marco Vassi was, without a doubt, the foremost erotic writer of our generation. Praised by Norman Mailer, Kate Millett, Saul Bellow, and Gore Vidal, he was not only the ultimate sexual explorer, but a literary craftsman whose own life experiences became the stuff of his fiction—expanded, of course, by a grand imagination and a full sense of the absurd."), _c('BR'), _c('BR'), _vm._v(" Tragically, Vassi died from pneumonia after he had contracted AIDS.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qy3EBr/tc-custom/9781497635036.jpg?1702842817843",
      "alt": "This image is the cover for the book Tackling the Team, The Vassi Collection"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tackling the Team, The Vassi Collection\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“I suppose I should have stuck it through until graduation if I hadn’t met Jeff. The only alternative was getting a job, and without a degree there weren't too many interesting possibilities. Also, on the basic level of material comfort, I didn’t have anything to complain about. The campus was extremely pretty. On the night I first saw Jeff I had been without sex for almost three months, and it was making me more than a little jittery. It may say sound unladylike to put it this way, but when he asked me to the party, all I could think was . . . ”"), _c('br'), _c('br'), _vm._v(" Read more of Julie Ann DeWitt’s scintillating tale, as told to Marco Vassi. "), _c('i', [_vm._v("Tackling the Team")]), _vm._v(" is one of Vassi’s most daring works, written in the voice of Julie Ann DeWitt (as told to Marco Vassi).")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0